<template>
<div class="course-single">
    <div class="mb-2 px-2">
        <!-- <alert style="position: relative!important; width: 100%; background-color: #c2454b!important;" v-if="course.has_repay!== null
        && course.has_repay.level === 'course' &&
         !course.has_repay.locked &&
         course.subscription_limit &&
        course.has_repay.number_of_days !== null &&
         course.progress < 100 &&
          hasPaid" show-alert :message="`Your subscription will expire on the  ${getExpirationDate}`">

            <vue-countdown-timer @start_callback="startCallBack('event started')" @end_callback="endCallBack('event ended')" :start-time="new Date()" :end-time="new Date(course.has_repay.number_of_days)" :interval="1000" :start-label="'Until start:'" :end-label="''" label-position="begin" :end-text="'Course Expired!'" :day-txt="'days'" :hour-txt="'hours'" :minutes-txt="'minutes'" :seconds-txt="'seconds left to complete the course'">
            </vue-countdown-timer>
        </alert>
        <alert style="position: relative!important; width: 100%; background-color: #c2454b!important; " v-if="course.has_repay!== null && course.has_repay.level === 'course' && course.has_repay.locked && course.subscription_limit && hasPaid" show-alert :message="`Your Course  Subscription has expired today Kindly Repay for this course`" />
        <alert tyle="position: relative!important; width: 100%; background-color: #c2454b!important;" v-if="course.has_repay!== null
                       && course.has_repay.level === 'program'
                       &&  !course.has_repay.locked
                       && course.subscription.subscription_limit
                       && course.has_repay.number_of_days !== null
                       && course.progress < 100 && hasPaid" show-alert :message="`Your Program subscription will expire on the  ${getExpirationDate}`">

            <vue-countdown-timer @start_callback="startCallBack('event started')" @end_callback="endCallBack('event ended')" :start-time="new Date()" :end-time="new Date(course.has_repay.number_of_days)" :interval="1000" :start-label="'Until start:'" :end-label="''" label-position="begin" :end-text="'Program Expired!'" :day-txt="'days'" :hour-txt="'hours'" :minutes-txt="'minutes'" :seconds-txt="'seconds left to complete the program'">
            </vue-countdown-timer>

        </alert>
        <alert style="position: relative!important; width: 100%; background-color: #c2454b!important;" v-if="course.has_repay!== null && course.has_repay.level === 'program' && course.has_repay.locked
        && course.subscription_limit && hasPaid" show-alert :message="`Your Program  Subscription has expired today Kindly repay for the program `" />-->
    </div>

    <div class="w-full md:flex items-center header px-4 pt-4">

        <div class="w-full self-start md:w-2/3">

            <br />

            <div class="mb-2 px-2">

                <div class="text-2xl md:text-4xl text-white font-extrabold mb-6">
                    {{ course.title }}

                </div>
                <div class="float-right">
                       <vue-ellipse-progress :size="100" :progress="course.progress ? parseInt(course.progress) : 0" animation="reverse 700 400">
                    <span slot="legend-value">%</span>
                </vue-ellipse-progress>
                </div>
                
                <div class="text-base font-medium text-white mb-8 md:w-3/4">
                    {{ course.caption }}
                </div>
             
                <div class="stats mb-6 text-white w-full flex items-center justify-between font-bold">
                    <!-- <div
              class="w-full md:w-auto flex items-center justify-between md:mb-0 mb-6"
            > -->
                    <span class="bg-white px-3 font-normal py-1 rounded bestseller md:mr-6 font-bold">BESTSELLER</span>
                    <span class="mr-1 md:mr-3">
                        <star-rating v-model="course.aggregate_rating" :increment="0.1" read-only :star-size="20"></star-rating>
                    </span>
                    <!-- </div> -->
                    <!-- <span>{{ course.enrollee }} enrolled</span> -->
                </div>
                <div class="mb-4 text-white flex flex-wrap justify-between">
                    <span class="">Created by: {{ author }} </span>
                    <span class="">Last updated: {{ course.updated_at | dateFilter }}</span>
                    <span class="">Language: English</span>
                </div>
                <div class="actions">
                    <template v-if="!hasPaid">
                        <!--              <lms-button-->
                        <!--                v-if="!courseInCart"-->
                        <!--                @click="addToCart"-->
                        <!--                class="mr-6"-->
                        <!--                color="#fff"-->
                        <!--                >Add to Cart</lms-button-->
                        <!--              >-->
                        <div v-if="course.course_subscription_type === 'specify'">
                            <lms-button color="#fff" v-if="!courseInCart && course.payment_type !== 'free'" @click="addToCart" class="my-1">Enroll</lms-button>
                            <lms-button color="#fff" v-if="!courseInCart && course.payment_type == 'free'" @click="addToCart" class="my-1">Enroll Free</lms-button>
                        </div>
                        <div v-if="course.course_subscription_type === 'inherit'">
                            <lms-button color="#fff" v-if="!courseInCart && course.subscription.subscription_type !== 'free' && course.subscription.subscription_type !== 'bulk'" @click="addToCart" class="my-1">Enroll</lms-button>
                            <lms-button color="#fff" v-if="!courseInCart &&  course.subscription.subscription_type === 'free' " @click="addToCart" class="my-1">Enroll Free</lms-button>
                            <lms-button color="#fff" v-if="!courseInCart &&  course.subscription.subscription_type === 'bulk' " @click="processPayment(course.program_id,course.subscription.subscription_cost)" class="my-1">Bulk Enroll</lms-button>
                        </div>
                        <!--<lms-button color="#fff" v-if="!courseInCart && course.payment_type !== 'free'" @click="addToCart" class="my-1 mr-6">Enroll</lms-button>-->
                        <!--<lms-button color="#fff" v-if="!courseInCart && course.payment_type === 'free'" @click="addToCart" class="my-1 mr-6">Enroll Free</lms-button>-->

                        <lms-button v-if="courseInCart" @click="$router.push({ name: 'learner-cart' })" color="#fff" class="mr-6">Go to Cart</lms-button>
                        <lms-button @click="addToWishList" class="my-2" v-if="!courseInWishList" border>
                            <i class="far fa-heart"></i> Wishlist
                        </lms-button>
                        <lms-button v-else @click="$router.push({ name: 'learner-wishlist' })" style="background: green">View in WishLists</lms-button>
                    </template>

                    <template v-else-if="hasPaid && course.progress < 100 && !course.has_repay.locked && course.has_repay!== null">
                        <lms-button @click="
                  $router.push({
                    name: 'learner-home',
                    params: { course_id: course.id },
                  })
                " color="#fff" class="mr-6">Continue</lms-button>
                    </template>
                    <template v-else-if="course.has_repay!== null && course.has_repay.level === 'course' && course.has_repay.locked && course.subscription_limit">
                        <lms-button @click="processPayment({user,course})" color="#fff" class="mr-6">Repay for this course to continue</lms-button>
                    </template>
                    <template v-else-if="course.has_repay!== null && course.has_repay.level === 'program' && course.has_repay.locked">
                        <lms-button @click="processPayment({user,course})" color="#fff" class="mr-6">Repay for the program to continue</lms-button>
                    </template>
                    <template v-else-if="hasPaid && course.progress >= 100">
                        <lms-button color="#fff" @click="
                  $router.push({
                    name: 'learner-home',
                    params: { course_id: course.id },
                  })
                " class="mr-6">Course Completed</lms-button>
                    </template>
                </div>
            </div>
        </div>
        <div class="w-full md:w-1/3 flex-shrink mb-2 pb-2">
            <div class="mb-4 flex flex-col">
                <div class="price text-white text-3xl md:text-5xl md:text-center">
                    {{ coursePrice }}
                </div>
                <div class="media relative">
                    <!-- make any media scale nicely -->
                    <!-- <iframe class="media-item object-cover" src="https://www.youtube.com/embed/HIlG2NKnsVA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                    <img v-if="!hasValidVideo" class="media-item object-cover w-full" :src="courseImage" alt="" />
                    <div class="overlay absolute top-0 left-0 h-full w-full flex justify-center items-center px-5 pt-5">
                        <span v-if="hasValidVideo" class="text-4xl cursor-pointer p-4 justify-center rounded-full h-20 w-20 flex items-center border-4 text-white">
                            <i class="fas fa-play"></i>
                        </span>
                    </div>
                </div>
                <div v-if="hasValidVideo" class="text-center text-white font-bold mt-2">
                    Watch overview video
                </div>
            </div>
        </div>
    </div>
    <div class="course-details bg-white shadow mt-4 p-4">
        <div class="md:px-12 py-4 w-3/3">
            <div class="desc text-black">
                <div class="text-tenant-color text-2xl font-semibold">
                    Description
                </div>
                <p class="story">{{getStrippedText(course.description)}}</p>
            </div>

            <div class="require  my-2">
                <div class="text-tenant-color text-2xl font-semibold">
                    Requirements
                </div>
                <div class="flex flex-col text-black">
                    <div class="item">
                        <p class="story">{{getStrippedText(course.resources_required)}}</p>
                    </div>
                </div>
            </div>

            <div class="require  my-2">
                <div class="text-tenant-color text-2xl font-semibold">
                    What you will learn
                </div>
                <div class="flex flex-col text-black">
                    <div class="item">
                        <p class="story">{{getStrippedText(course.skills_gained)}}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="featured-review w-2/3">
        <div class="px-12">
          <div class="text-tenant-color text-2xl font-semibold my-6">
            Featured Review
          </div>
          <div class="flex">
            <div class="mr-4">
              <div
                style="height: 67px; width: 67px;"
                class="self-start rounded"
              >
                <img
                  class="object-cover w-100 h-100 rounded-full"
                  src="https://avatars2.githubusercontent.com/u/15062380?s=460&u=2f400d9555dc07bc4d2c2d25483ddba570fef29b&v=4"
                  alt=""
                />
              </div>
            </div>
            <div class="">
              <div class="text-tenant-color font-semibold text-lg mb-1">
                Dapo Believe
              </div>
              <div class="text-black mb-6">
                <div class="mb-4">2 months ago</div>
                <div>
                  Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
                  consectetur adipisicing elit. Nisi voluptates enim maxime
                  quos, quod. Architecto rerum eum rem ut necessitatibus.
                </div>
              </div>
              <div class="inline-flex items-center">
                <span class="mr-4 text-gray-500"
                  >Was this review helpful?
                </span>
                <span
                  class="px-4 rounded border tenant-border text-tenant-color cursor-pointer mr-4"
                  >Yes</span
                >
                <span
                  class="px-4 rounded border tenant-border text-tenant-color cursor-pointer"
                  >No</span
                >
              </div>
            </div>
          </div>
        </div>
      </div> -->
        <div class="course-content w-full md:w-4/6 mt-4">
            <div class="md:px-12">
                <div class="text-tenant-color text-2xl font-semibold my-6">
                    Course Content
                </div>
                <div>
                    <accordion :items="x.lessons" :title="`${x.title}`" :key="index" v-for="(x, index) in sortedModules" />
                </div>
            </div>
        </div>
        <div class="featured-review w-full md:w-2/3 mt-24">
            <div class="md:px-12">
                <!-- <div class="text-tenant-color text-2xl font-semibold my-6">
                    All Reviews
                </div> -->
                <!-- <div v-for="testimonial in testimonials" :key="testimonial.id" class="flex mb-8">
                    <!-- <div class="mr-4">
                        <div style="height: 50px; width: 50px;" class="self-start rounded">
                            <img v-if="testimonial.user !== null && testimonial.user.image !== null " class="object-cover w-100 h-100 rounded-full" :src="testimonial.user.image" alt="" />
                            <img v-else class="object-cover w-150 h-150 rounded-full" src="https://picsum.photos/id/1011/3648.jpg" alt="" />
                        </div>
                    </div> -->
                    <!-- <div class=""> -->
                        <!-- <div class="text-tenant-color font-semibold text-lg mb-1" v-if="testimonial.user !== null">
                            {{ testimonial.user.name }}
                        </div>
                        <div class="text-black  mb-6">
                            <div class="mb-4 text-xs">
                                {{ testimonial.created_at | fromNow }}
                            </div>
                            <div>
                                {{ testimonial.testimonial }}
                            </div>
                        </div> -->
                        <!-- <div class="inline-flex items-center">
                <span class="mr-4 text-gray-500"
                  >Was this review helpful?
                </span>
                <span
                  class="px-4 rounded border tenant-border text-tenant-color cursor-pointer mr-4"
                  >Yes</span
                >
                <span
                  class="px-4 rounded border tenant-border text-tenant-color cursor-pointer"
                  >No</span
                >
              </div> -->
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations,
    
} from "vuex";
import _get from "lodash.get";
import Alert from "../../../components/learner/alert";
import moment from 'moment'
import FormActions from "@/mixins/FormActions";
export default {
    name: "single-course",
    mixins: [FormActions],
    data() {
        return {
            fullDetails: false,
            detailsText: "+ see more",
            videoFormats: ["mp4"],
            sortedModules: null,
            testimonials: null,
            paidCourses: this.$store.state.learner.courses,
        };
    },
    watch: {
        fullDetails: function (newVal, oldVal) {
            if (newVal) {
                this.detailsText = "- see less";
            } else {
                this.detailsText = "+ see more";
            }
        },
    },
    methods: {
        ...mapActions([
            "fetchLearnerNewCourse",
            "learnerAddToCart",
            "learnerAddToWishlist",
            "learnerPurchaseProgram"
        ]),
        ...mapMutations(["updateLoader"]),
        sortModules(modules) {
            modules.sort((a, b) => {
                return a.module_number - b.module_number;
            });
        },
        nairaToKobo(amount) {
            return (amount * 100).toFixed(0);
        },
        async purchaseProgram(programId, amount) {

            let res = await this.learnerPurchaseProgram({
                programId: programId,
                amount: amount
            })
            if (res.status === 201 || res.status === 200) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Transaction Successful",
                });
                this.$router.push({
                    name: 'learner-enrolled-courses',

                })

            } else {
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.data.title,
                });
            }

        },

        processPayment(programId, amount) {
            let that = this;
            let handler = PaystackPop.setup({
                key: "pk_live_921e367ae8e08ed0badd3b7081af68c7c0c49fdb",
                email: this.user.email,
                amount: this.nairaToKobo(parseFloat(amount)),
                channels: ["card", "bank", "ussd"],
                metadata: {
                    custom_fields: [{
                        user_name: this.user.first_name,
                        variable_name: this.user.phone_number,
                    }, ],
                },
                callback: function (response) {
                    that.ref = response.reference;
                    that.purchaseProgram(programId, amount)
                },
                onClose: function () {
                    //console.log("window closed");
                },
            });

            handler.openIframe();
        },
        // click button
        async addToCart() {
            this.learnerAddToCart({
                ...this.course,
            });
            await this.$swal({
                title: "Item Successfully Added to Cart",
                cancelButtonText: "Continue Shopping",
                confirmButtonText: "Go To Cart",
                showCancelButton: true,
            }).then((res) => {
                if (res.isConfirmed) {
                    this.$router.push({
                        name: "learner-cart"
                    });
                }
            });
        },

        startCallBack: function (x) {
            console.log(x)
        },
        endCallBack: function (x) {
            console.log(x)
        },

        async addToWishList() {
            this.learnerAddToWishlist({
                ...this.course,
            });
            await this.$swal({
                title: "Item Successfully Added to WishList",
                cancelButtonText: "Continue Shopping",
                confirmButtonText: "Go To WishList",
                showCancelButton: true,
            }).then((res) => {
                if (res.isConfirmed) {
                    this.$router.push({
                        name: "learner-wishlist"
                    });
                }
            });
        },
        // pass course as payload to addToCart function
        // send to backend
        // set in state
    },
    computed: {
        ...mapGetters({
            course: "getLearnerNewCourse",
            cart: "getLearnerCart",
            wishlist: "getLearnerWish",
            user: "getUser",
            settings: "getSettings"
        }),
        courseImage() {
            let course_image = this.course.course_image.toString()
            if (course_image) {
                if (course_image.includes(process.env.VUE_APP_TENANT_BUCKET)) {
                    let replacement = "https://media.edclearn.com";

                    if (this.settings.data_bypass) {
                        replacement = "https://media.main.edclearn.com";
                    }

                    var parts = course_image.split('.com', 2);
                    return replacement + parts[1];
                } else {
                    return course_image
                }
            }

        },
        skills() {
            return this.course.skills_gained.split(",");
        },
        getExpirationDate() {
            if (typeof this.course.has_repay !== 'undefined' && this.course.has_repay.number_of_days !== null) {
                return moment(this.course.has_repay.number_of_days).format(' Do MMMM  YYYY');
            }
            return null

        },

        author() {
            return this.course.course_instructor ?
                `${this.course.course_instructor.first_name} ${this.course.course_instructor.last_name}` :
                "Course Instructor";
        },
        hasValidVideo() {
            let x = this.course.course_image.split(".");
            return this.videoFormats.includes(x[x.length - 1]);
        },
        coursePrice() {
            return typeof this.course.price !== "undefined" && this.course.course_subscription_type === 'specify' &&
                this.course.payment_type !== "free" ?
                `${this.course.currency}${this.course.price}` : this.course.subscription !== null &&
                this.course.course_subscription_type === 'inherit' &&
                this.course.subscription.status_subscription === 'internal' ?
                '' : this.course.subscription !== null && this.course.course_subscription_type ?
                `${this.course.subscription.subscription_cost}` : "FREE";
        },
        courseInWishList() {
            return this.wishlist.some(wish => {
                return wish.course.id === this.course.id
            });
        },
        courseInCart() {
            return Object.keys(this.cart).includes(this.course.id);
        },
        hasPaid() {
            return typeof this.paidCourses[this.course.id] === "object";
        },
    },
    components: {
        Alert,
        accordion: () => import("@/components/general/accordion"),
        LmsButton: () => import("@/components/general/button"),
    },
    async created() {
        this.updateLoader(true)
        let res = await this.fetchLearnerNewCourse({
            id: this.$route.params.id,
        });

        // this.testimonials = await this.fetchCourseTestimonial({
        //     id: this.$route.params.id,
        // });

        this.sortedModules = res.data.data.course.modules.sort((a, b) => {
            return a.module_number - b.module_number;
        });

        this.updateLoader(false)
        // //console.log({ rs: this.sortedModules });
    },
    mounted() {
        const payPopup = document.createElement("script");
        payPopup.setAttribute("src", "https://js.paystack.co/v2/inline.js");
        payPopup.async = true;
        document.head.appendChild(payPopup);
    }
};
</script>

<style lang="scss">
.course-single {
    .header {
        background-color: color(lms-tenant);
    }

    .stats {
        .bestseller {
            color: color(lms-tenant);
        }
    }

    .media {
        height: 200px;

        .media-item {
            height: 100%;
            width: 100%;
        }

        .overlay {
            background-color: rgba(0 0 0 / 0.6);
        }
    }

    .keypoints {
        .top {
            color: color(lms-tenant);
        }

        .point {
            color: #000;

            span {
                color: color(lms-tenant);
            }
        }
    }

    .course-details {
        .showFull {
            max-height: 130px;
            overflow: hidden;
            margin-bottom: 2rem;
        }

        .shade {
            background: linear-gradient(180deg,
                    #ffffff00 0%,
                    #ffffffc7 50%,
                    #ffffff 100%);
            filter: blur(0.2px);
            -webkit-filter: blur(0.2px);
            height: 7rem;
            margin-top: -9rem;
        }
    }
}
</style>
